import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const installmentPaymentReserveReject = http.patch(
  createMockEndpoint('/shop/:id/reserved_split_payment/:reservedShopSplitPaymentInformationId/reject'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
